module.exports = __webpack_public_path__ + "img/school.08c5d645.svg";